import { Reducer } from 'redux';
import { IAuthState, Types } from './types';

export const INITIAL_STATE: IAuthState = {
  azureToken: '',
  azureExpireIn: 0,
  azureDateTimeExpiration: 0
};

type AuthAction = {
  type: Types;
  payload: {
    azureToken: string;
    azureExpireIn: number;
    azureDateTimeExpiration: number;
  };
};

const reducer: Reducer<IAuthState, AuthAction> = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case Types.UPDATE_AUTH_STATE_SUCCESS:
      return {
        ...state,
        azureToken: action.payload.azureToken,
        azureExpireIn: action.payload.azureExpireIn,
        azureDateTimeExpiration: action.payload.azureDateTimeExpiration
      };
    case Types.LOAD_AUTH_STATE:
      return {
        ...state,
        azureToken: action.payload.azureToken,
        azureDateTimeExpiration: action.payload.azureDateTimeExpiration
      };
    default:
      return state;
  }
};

export default reducer;
